/**
 * QRMaps Design System - Color Tokens
 *
 * This file defines all color values used throughout the application.
 * Colors are extracted from existing usage in MainMap.js, NavigationPanel.js, and other components.
 */

import { brand, cruisePalette } from './brand';

export const colors = {
  brand,
  // Primary palette shares the logo colour and its tints with Mantine.
  primary: {
    50: cruisePalette[0],
    100: cruisePalette[1],
    200: cruisePalette[2],
    300: cruisePalette[3],
    400: cruisePalette[4],
    500: brand.teal,
    600: brand.hover,
    700: cruisePalette[7],
    800: cruisePalette[8],
    900: cruisePalette[9],
  },

  // Map-specific colors (extracted from markerStyle function)
  map: {
    marker: '#007bff',           // Default marker color
    markerSelected: '#ff5a00',   // Selected marker (orange)
    markerHighlight: '#9c27b0',  // Cluster/highlight color (purple)
    lock: '#ff6b35',             // Lock marker color
    lockLayer: '#1d4ed8',        // Navigation Locks layer pins
    dockLayer: '#0f766e',        // Docks layer pins (teal)
    mapMarker: '#4CAF50',        // Map marker (green)
    routePoint: '#ff0000',       // A/B route markers (red)
    tempPoint: '#ff6b35',        // Temporary point marker
    poi: '#2563eb',             // Catalog route POI
    aiPoi: '#7c3aed',           // AI route discovery
  },

  // Chart colors (from NavigationPanel.js - chart datasets)
  charts: [
    '#f44336', // Red
    '#9c27b0', // Purple
    '#009688', // Teal
    '#ff9800', // Orange
    '#795548', // Brown
    '#607d8b', // Blue Grey
    '#e91e63', // Pink
    '#4caf50', // Green
  ],

  // Water level gradient (from NavigationPanel.js)
  waterLevel: {
    high: '#1744a6',
    mid: '#1741a3',
    low: '#174099',
  },

  // Building colors (from buildings layer style function)
  building: {
    default: '#0B40B1FF',
    important: '#0D7805',
    castle: '#b31515',
    church: '#b31515',
    cathedral: '#b31515',
    named: '#CC7373FF',
  },

  // Semantic colors
  success: '#4caf50',
  warning: '#ff9800',
  error: '#d32f2f',
  info: '#2196f3',

  // Neutrals - Grayscale palette
  neutral: {
    0: '#ffffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    1000: '#000000',
  },

  // Overlay/transparency colors
  overlay: {
    light: 'rgba(255, 255, 255, 0.5)',  // Shade layer
    dark: 'rgba(0, 0, 0, 0.3)',         // Shadow overlay
    selection: 'rgba(25, 118, 210, 0.10)', // Selection rectangle fill
  },

  // Border colors
  border: {
    light: 'rgba(0, 0, 0, 0.1)',
    normal: 'rgba(0, 0, 0, 0.2)',
    dark: 'rgba(0, 0, 0, 0.3)',
    selection: '#1976d2',
  },
};
